import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'reflexbox';
import DisclosureTrigger from 'components/DisclosureTrigger';
import Form from 'components/Form';
import Button from 'components/Button';
import FormInput from 'components/Input';
import Text from 'components/Text';
import { getText } from 'helpers/i18n';
import Validate from 'helpers/Validate';
// Styles
import './newList.styles.scss';

export default class NewList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            listName: '',
            showInput: false,
        };

        this.onNewListChange = this.onNewListChange.bind(this);
        this.onCreateList = this.onCreateList.bind(this);
    }

    componentDidMount() {
        this.props.setError();
    }

    onSetInputVisibility(value) {
        this.setState({
            showInput: value,
        });
    }

    onNewListChange(name, value) {
        this.setState({
            listName: value,
        });
        this.props.setError();
    }

    onCreateList() {
        const { addShoppingList } = this.props;
        // Trigger input validation on click
        const newListValidator = Validate(this.state.listName, this.newListInput.props.validator);
        if (!newListValidator.valid) {
            this.newListInput.setState({
                validate: Validate,
                validation: newListValidator,
            });
            return;
        }
        addShoppingList(this.state.listName);

        // Set input back to empty
        this.setState({
            listName: '',
            showInput: false,
        });
        this.newListInput.state.value = '';
    }

    renderError() {
        const { error } = this.props;

        if (error) {
            return (
                <p className="error-helper">
                    {error}
                </p>
            );
        }

        return null;
    }

    render() {
        return (
            <Box py={2} className="listselector__newlist">
                {!this.state.showInput &&
                    <DisclosureTrigger
                        onTrigger={this.onSetInputVisibility.bind(this, true)}
                        text="new_list_button_text"
                        disclosed={this.state.showInput}
                    />
                }
                {this.state.showInput &&
                    <Form>
                        <label htmlFor="newList"><Text textKey="new_list_modal_label" /></label>
                        <FormInput
                            ref={(input) => { this.newListInput = input; }}
                            type="text"
                            id="newList"
                            name="newList"
                            ariaLabel={getText('new_list_modal_label')}
                            ariaRequired
                            onChange={this.onNewListChange}
                            validator={{
                                required: true,
                                errorMessage: {
                                    required: 'new_list_modal_min_length_error',
                                },
                            }}
                        />
                        {this.renderError()}
                        <Flex className="newList__options" py={1} >
                            <Box w={1 / 2}>
                                <Button
                                    theme="secondary"
                                    ariaLabel={getText('new_list_modal_cancel_button')}
                                    text="new_list_modal_cancel_button"
                                    onClick={this.onSetInputVisibility.bind(this, false)}
                                />
                            </Box>
                            <Box w={1 / 2}>
                                <Button
                                    theme="primary"
                                    type="submit"
                                    ariaLabel={getText('new_list_modal_create_button')}
                                    text="new_list_modal_create_button"
                                    onClick={this.onCreateList}
                                />
                            </Box>
                        </Flex>
                    </Form>
                }
            </Box>
        );
    }
}

NewList.propTypes = {
    addShoppingList: PropTypes.func.isRequired,
    setError: PropTypes.func.isRequired,
    error: PropTypes.string,
};
